import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default function AdminRoute({ children }) {
  const [status, setStatus] = useState('checking'); // checking | ok | invalid

  useEffect(() => {
    const token = localStorage.getItem('hrv_admin_token');
    if (!token) { setStatus('invalid'); return; }
    fetch(`${API_URL}/admin/verify`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => {
        if (d.valid) {
          // Refresh stored admin info in case it changed
          localStorage.setItem('hrv_admin_info', JSON.stringify(d.admin));
          setStatus('ok');
        } else {
          setStatus('invalid');
        }
      })
      .catch(() => setStatus('invalid'));
  }, []);

  if (status === 'checking') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1a202c' }}>
        <div style={{ color: '#a0aec0', fontSize: '0.9rem' }}>Verifying admin session…</div>
      </div>
    );
  }

  if (status === 'invalid') {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
